import type { REQUEST_TYPE } from '@/constants/request-type'
import { apiStudent } from '@/lib/api-manager'

export interface GetStudentOpenRequestEligibilityItemResponse {
  allowed: boolean
  reason?: string
}

export interface GetStudentOpenRequestEligibilityByTypeResponse {
  [REQUEST_TYPE.EXTERNAL_TRANSFER
    .id]: GetStudentOpenRequestEligibilityItemResponse
  [REQUEST_TYPE.CREDIT_TRANSFER
    .id]: GetStudentOpenRequestEligibilityItemResponse
  [REQUEST_TYPE.CHANGE_OF_MAJOR
    .id]: GetStudentOpenRequestEligibilityItemResponse
}

export async function getStudentOpenRequestEligibilityByType(): Promise<GetStudentOpenRequestEligibilityByTypeResponse> {
  return (await apiStudent.get('/v1/requests/open-eligibility')).data.data
}
